// 1:1 port of eb-ui packages/attendee/social-share/src/tracking/trackShareAction.ts.
// `@eventbrite/site-analytics` → the `legacy-infra.site-analytics` bridge
// (registry v0.0.13, peers react ^18||^19). `trackAnalyticsEvent` is GA-guarded
// upstream, so it no-ops safely where GA isn't wired (GA→Heap deprecation).
import { trackAnalyticsEvent } from '@eventbrite/legacy-infra.site-analytics';

const GA_ACTION_SHARE_EVENT = 'Share';

export enum ShareType {
    Facebook = 'facebook',
    LinkedIn = 'linkedin',
    WhatsApp = 'whatsapp',
    FacebookMessenger = 'facebookMessenger',
    Twitter = 'twitter',
    Email = 'email',
}

const shareMapping = {
    [ShareType.Facebook]: 'fb',
    [ShareType.LinkedIn]: 'li',
    [ShareType.WhatsApp]: 'wa',
    [ShareType.FacebookMessenger]: 'fbm',
    [ShareType.Twitter]: 'tw',
    [ShareType.Email]: 'strongmail',
};

export const getLabelFromShareType = (type: ShareType): string =>
    shareMapping[type];

export const trackShareAction = ({
    category,
    label,
    dimensions = {},
}: {
    label: string;
    category: string;
    dimensions?: object;
}) =>
    trackAnalyticsEvent({
        action: GA_ACTION_SHARE_EVENT,
        category: category,
        dimensions,
        label,
    });
